import { Rolle } from '../../../models';
import { client } from '../../client';
import { getQueryURL } from '../requestService';
import { SubEntityRequestService } from '../subEntityRequestService';

export default class RolleService extends SubEntityRequestService<Rolle>
{
    constructor() {
        super('rollemaster', 'roller');
    }
    deleteRoller = async (baseId: number, ids: number[]) => client.delete<void>(getQueryURL(`${this.getBaseRoute(baseId)}`, {ids}));
}